
































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  GET_USER_DETAILS,
  MUST_PERFORM_DATA_CLEANSING,
  PERFORM_DATA_CLEANSING,
  PERFORM_DATA_CLEANSING_ERRORS,
  SET_MUST_PERFORM_DATA_CLEANSING,
  SET_PERFORM_DATA_CLEANSING_ERRORS,
} from '@/types/lobby.types';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails, UserData } from '@/models/UserDetails.model';
import { RESET_STORE } from '@/types/store.types';

@Component({})
export default class PerformDataCleansingModal extends Vue {

  @Inject() public $validator;

  @Action(PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public performDataCleansing;
  @Action(RESET_STORE) public resetStore;
  @Action(GET_USER_DETAILS, StoreNamespace.LOBBY) public getUserDetails;

  @Mutation(SET_PERFORM_DATA_CLEANSING_ERRORS, StoreNamespace.LOBBY) public setPerformDataCleansingErrors;
  @Mutation(SET_MUST_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public setMustPerformDataCleansing;

  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(MUST_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public mustPerformDataCleansing!: boolean;
  @Getter(PERFORM_DATA_CLEANSING_ERRORS, StoreNamespace.LOBBY) public performDataCleansingErrors!: string[];

  public userData: UserData = {};

  public mounted() {
    this.getUserDetails()
        .then((data: UserData) => {
          this.userData = {
            email: data.emailAddress,
            phone: data.telephone,
          };
        });
    this.setPerformDataCleansingErrors([]);
  }

  public closeDialog(): void {
    this.setMustPerformDataCleansing(false);
    this.$emit('onCancel');
  }

  public onPerformDataCleansing(): void {
    this.$validator.validateAll('dataCleansingForm').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        this.performDataCleansing({ requestBody: this.userData });
      }
    });
  }

  public destroyed() {
    this.setMustPerformDataCleansing(false);
  }

}
